import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import styles from "./NotifyModal.module.css";
import bellWhite from "assets/bellWhite.svg";
import Portal from "Shared/Portal";

const DISPLAY_MS = 1250;
const EXIT_MS = 500;

export function NotifyModal({ isOpen, onClose }) {
  const { t } = useTranslation();
  const bellRef = useRef(null);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setIsExiting(false);
      return;
    }

    if (bellRef.current) {
      bellRef.current.classList.remove(styles.bellRing);
      void bellRef.current.offsetWidth;
      bellRef.current.classList.add(styles.bellRing);
    }

    const displayTimer = setTimeout(() => {
      setIsExiting(true);
      const exitTimer = setTimeout(() => {
        onClose?.();
        setIsExiting(false);
      }, EXIT_MS);
      return () => clearTimeout(exitTimer);
    }, DISPLAY_MS);

    return () => clearTimeout(displayTimer);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <Portal>
      <div className={styles.overlay}>
        <div className={`${styles.modal} ${isExiting ? styles.modalExit : ""}`}>
          {/* ── Bell icon ── */}
          <div className={styles.bellWrap}>
            <img
              ref={bellRef}
              src={bellWhite}
              alt="notification bell"
              className={styles.bell}
            />
          </div>

          {/* ── Message ── */}
          <div className={styles.message}>
            {t(
              "notifyModal.message",
              "We'll Notify You When This Product Is Back in Stock"
            )}
          </div>
        </div>
      </div>
    </Portal>
  );
}

NotifyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

export default NotifyModal;
